import { render, staticRenderFns } from "./instanceBackup.vue?vue&type=template&id=60f970d4&"
import script from "./instanceBackup.vue?vue&type=script&lang=js&"
export * from "./instanceBackup.vue?vue&type=script&lang=js&"
import style0 from "./instanceBackup.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports